import React from 'react';
import ReactDOM from 'react-dom';
import { create as createAPI } from 'api';
import { SubscribeModal, SubscribeNewsletter, TheHeader, Cookies, Crossword, CrosswordData, Wordle } from 'components';
import { ToastContainer } from 'react-toastify';
import NotificationService from 'services/notification.service';
import reportWebVitals from './reportWebVitals';
import Config from 'config';
import 'lang/i18n';

import 'theme/styles.scss';

createAPI({
    actions: {
        notification: NotificationService.send,
        error: NotificationService.error,
    },
});

// Crosswords
const crossword1 = CrosswordData.Crossword1Data;
const crossword2 = CrosswordData.Crossword2Data;
const crossword3 = CrosswordData.Crossword3Data;
const crossword4 = CrosswordData.Crossword4Data;
const crossword5 = CrosswordData.Crossword5Data;
const crossword6 = CrosswordData.Crossword6Data;
const crossword7 = CrosswordData.Crossword7Data;
const crossword8 = CrosswordData.Crossword8Data;
const crossword9 = CrosswordData.Crossword9Data;
const crossword12 = CrosswordData.Crossword12Data;
const crossword13 = CrosswordData.Crossword13Data;

const elements = {
    ...(Config.isDev
        ? {
              header: 'tmp-header',
              toastContainer: 'tmp-toastContainer',
              suscribeModal: 'tmp-subscribeModal',
              suscribeNewsletter: 'tmp-subscriptionForm',
              cookies: 'tmp-cookies',
              crossword1: 'tmp-crossword1',
              crossword2: 'tmp-crossword2',
              crossword3: 'tmp-crossword3',
              crossword4: 'tmp-crossword4',
              crossword5: 'tmp-crossword5',
              crossword6: 'tmp-crossword6',
              crossword7: 'tmp-crossword7',
              crossword8: 'tmp-crossword8',
              crossword9: 'tmp-crossword9',
              crossword12: 'tmp-crossword12',
              crossword13: 'tmp-crossword13',
              wordle1: 'tmp-wordle1',
              wordle2: 'tmp-wordle2',
              wordle3: 'tmp-wordle3',
              wordle4: 'tmp-wordle4',
              wordle5: 'tmp-wordle5',
          }
        : {
              header: 'masthead',
              toastContainer: 'toastContainer',
              suscribeModal: 'subscribeModal',
              suscribeNewsletter: 'subscriptionForm',
              cookies: 'cookiesContainer',
              crossword1: 'crossword1',
              crossword2: 'crossword2',
              crossword3: 'crossword3',
              crossword4: 'crossword4',
              crossword5: 'crossword5',
              crossword6: 'crossword6',
              crossword7: 'crossword7',
              crossword8: 'crossword8',
              crossword9: 'crossword9',
              crossword12: 'crossword12',
              crossword13: 'crossword13',
              wordle1: 'wordle1',
              wordle2: 'wordle2',
              wordle3: 'wordle3',
              wordle4: 'wordle4',
              wordle5: 'wordle5',
          }),
};

// Header
if (document.getElementById(elements.header)) {
    ReactDOM.render(
        <React.StrictMode>
            <TheHeader animated />
        </React.StrictMode>,
        document.getElementById(elements.header)
    );
}

// Toast container
if (document.getElementById(elements.toastContainer)) {
    ReactDOM.render(
        <React.StrictMode>
            <ToastContainer newestOnTop />
        </React.StrictMode>,
        document.getElementById(elements.toastContainer)
    );
}

// Subscribe modal
if (document.getElementById(elements.suscribeModal)) {
    ReactDOM.render(
        <React.StrictMode>
            <SubscribeModal />
        </React.StrictMode>,
        document.getElementById(elements.suscribeModal)
    );
}

// Subscribe newsletter
if (document.getElementById(elements.suscribeNewsletter)) {
    ReactDOM.render(
        <React.StrictMode>
            <SubscribeNewsletter className="subscriptionForm mt-2" />
        </React.StrictMode>,
        document.getElementById(elements.suscribeNewsletter)
    );
}

// Cookies
if (document.getElementById(elements.cookies)) {
    ReactDOM.render(
        <React.StrictMode>
            <Cookies />
        </React.StrictMode>,
        document.getElementById(elements.cookies)
    );
}

// Crosswords
if (document.getElementById(elements.crossword1)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword1} id="crucigrama-1" dueDate="2021-08-02" />
        </React.StrictMode>,
        document.getElementById(elements.crossword1)
    );
}
if (document.getElementById(elements.crossword2)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword2} id="crucigrama-2" dueDate="2021-08-09" />
        </React.StrictMode>,
        document.getElementById(elements.crossword2)
    );
}
if (document.getElementById(elements.crossword3)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword3} id="crucigrama-3" dueDate="2021-08-16" />
        </React.StrictMode>,
        document.getElementById(elements.crossword3)
    );
}
if (document.getElementById(elements.crossword4)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword4} id="crucigrama-4" dueDate="2021-08-23" />
        </React.StrictMode>,
        document.getElementById(elements.crossword4)
    );
}
if (document.getElementById(elements.crossword5)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword5} id="crucigrama-5" dueDate="2021-08-30" />
        </React.StrictMode>,
        document.getElementById(elements.crossword5)
    );
}

if (document.getElementById(elements.crossword6)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword6} id="crucigrama-6" dueDate="2021-12-01" />
        </React.StrictMode>,
        document.getElementById(elements.crossword6)
    );
}

if (document.getElementById(elements.crossword7)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword7} id="crucigrama-7" dueDate="2022-12-01" />
        </React.StrictMode>,
        document.getElementById(elements.crossword7)
    );
}

if (document.getElementById(elements.crossword8)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword8} id="crucigrama-8" dueDate="2023-07-10" />
        </React.StrictMode>,
        document.getElementById(elements.crossword8)
    );
}

if (document.getElementById(elements.crossword9)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword9} id="crucigrama-9" dueDate="2023-12-04" />
        </React.StrictMode>,
        document.getElementById(elements.crossword9)
    );
}

if (document.getElementById(elements.crossword12)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword12} id="crucigrama-12" dueDate="2025-07-01" />
        </React.StrictMode>,
        document.getElementById(elements.crossword12)
    );
}
if (document.getElementById(elements.crossword13)) {
    ReactDOM.render(
        <React.StrictMode>
            <Crossword {...crossword13} id="crucigrama-13" />
        </React.StrictMode>,
        document.getElementById(elements.crossword13)
    );
}

// Wordle
if (document.getElementById(elements.wordle1)) {
    ReactDOM.render(
        <React.StrictMode>
            <Wordle solutionWord="banco" />
        </React.StrictMode>,
        document.getElementById(elements.wordle1)
    );
}

if (document.getElementById(elements.wordle2)) {
    ReactDOM.render(
        <React.StrictMode>
            <Wordle solutionWord="fondo" />
        </React.StrictMode>,
        document.getElementById(elements.wordle2)
    );
}

if (document.getElementById(elements.wordle3)) {
    ReactDOM.render(
        <React.StrictMode>
            <Wordle solutionWord="valor" />
        </React.StrictMode>,
        document.getElementById(elements.wordle3)
    );
}

if (document.getElementById(elements.wordle4)) {
    ReactDOM.render(
        <React.StrictMode>
            <Wordle solutionWord="mixto" />
        </React.StrictMode>,
        document.getElementById(elements.wordle4)
    );
}

if (document.getElementById(elements.wordle5)) {
    ReactDOM.render(
        <React.StrictMode>
            <Wordle solutionWord="renta" />
        </React.StrictMode>,
        document.getElementById(elements.wordle5)
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
